import { number, object, string } from "yup";
import { useCommonComponentContext } from "@maysoft/common-component-react";

import useStrings from "../../useStrings";
import Helpers from "../../../commons/helpers";
import MessageTemplateCaseService from "../../../services/message/MessageTemplateCase.service";
import { Mode } from "../../../constants/enums";
import { IMessageTemplateCaseErrors } from "./useData";
import { IMessageTemplateCase } from "../../../commons/interfaces";

interface IProps {
    mode: Mode;
    data: IMessageTemplateCase;
    onGoBack: () => void;
    onChangeMode: (mode: Mode) => void;
    getDetail: (id: string) => Promise<void>;
    setIsEdited: React.Dispatch<React.SetStateAction<boolean>>;
    setError: React.Dispatch<React.SetStateAction<IMessageTemplateCaseErrors>>;
}

const useSubmit = ({ mode, data, setError, onGoBack, onChangeMode, setIsEdited, getDetail }: IProps) => {
    const schemaObject = object({
        templateType: number().required(),
        templateCode: string().required(),
        caseCode: string().required(),
        tenantCode: string().required(),
        serviceCode: string().required(),
    });

    const Strings = useStrings();

    const { onError, onSuccess, onHideLoading, onShowLoading } = useCommonComponentContext();

    const handleSubmit = async () => {
        if (mode === Mode.View) return onChangeMode(Mode.Update);

        try {
            await schemaObject.validate(data, { abortEarly: false });
            onShowLoading();

            const dataSubmit = {
                id: data?.id,
                caseCode: data?.caseCode,
                templateCode: data?.templateCode,

                organizationId: data?.organizationId || "0",
                serviceCode: data?.serviceCode,
                tenantCode: data?.tenantCode,
            };

            if (!Helpers.isNullOrEmpty(dataSubmit?.id)) {
                const result = await MessageTemplateCaseService.update(dataSubmit);

                const resultDetail = await MessageTemplateCaseService.getDetail(result?.id);

                await getDetail(resultDetail?.id);

                setIsEdited(false);
                onChangeMode(Mode.View);
                onSuccess(Strings.MESSAGE_TEMPLATE_CASE.UPDATE_SUCCESS);
            } else {
                await MessageTemplateCaseService.create(dataSubmit);

                onSuccess(Strings.MESSAGE_TEMPLATE_CASE.CREATE_SUCCESS);
                onGoBack();
            }
        } catch (error: any) {
            if (error.name === "ValidationError") {
                const validationError = Helpers.handleValidationError(error) as IMessageTemplateCaseErrors;
                setError(validationError);
                return;
            }
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
        }
    };

    return {
        handleSubmit,
    };
};

export default useSubmit;
